import { supabase } from "@/integrations/supabase/client";

export interface SendTransactionalEmailOptions {
  templateName: string;
  recipientEmail: string;
  idempotencyKey: string;
  templateData?: Record<string, unknown>;
}

import { EMAILS_PAUSED } from "@/lib/email/paused";

export async function sendTransactionalEmail(
  options: SendTransactionalEmailOptions
): Promise<{ success: boolean; error?: string }> {
  if (EMAILS_PAUSED) return { success: true };

  const session = await supabase.auth.getSession();
  const token = session.data.session?.access_token;

  if (!token) {
    return { success: false, error: "Usuário não autenticado" };
  }

  const response = await fetch("/lovable/email/transactional/send", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      templateName: options.templateName,
      recipientEmail: options.recipientEmail,
      idempotencyKey: options.idempotencyKey,
      templateData: options.templateData,
    }),
  });

  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    return { success: false, error: data.error || "Erro ao enviar email" };
  }

  return { success: true };
}
